/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Firebase from 'firebase'

// Containers
import Full from '@/containers/Full'

// Views - Icons
import FontAwesome from '@/views/icons/FontAwesome'
import SimpleLineIcons from '@/views/icons/SimpleLineIcons'

// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'
import Login from '@/views/pages/Login'
import Register from '@/views/pages/Register'

// import Users from '@/views/components/Users'
// import Settings from '@/views/components/Settings'

import ListLocalBusiness from '@/views/components/ListLocalBusiness'
import EditLocalBusiness from '@/views/components/EditLocalBusiness'
import ListOffer from '@/views/components/ListOffer'
import EditOffer from '@/views/components/EditOffer'

import ListUpload from '@/views/components/ListUpload'
import LocationUpload from '@/views/components/LocationUpload'
import Welcome from '@/views/components/Welcome'
import Reports from '@/views/components/Reports'
import Projects from '@/views/components/Projects'

import VTooltip from 'v-tooltip'
import VueFire from 'vuefire'
import Vuex from 'vuex'
import store from '../store'
import search_config from '../search'
import {db, auth} from '../firebase'

Vue.use(Vuex)
Vue.use(VueFire)
Vue.use(Router)
Vue.use(VTooltip)

const router = new Router({
  mode: 'history',
  store,
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      meta: {
        requiresAuth: true,
      },
      children: [

        {
          path: '/localbusiness',
          name: 'default_localbusiness',
          beforeEnter: (to, from, next) =>
          // checks for the existing user and forwards to the first child if there is one mapped
          db.ref('/OrganizationUsers').child(firebase.auth().currentUser.email.replace(/\./gi, "%2E")).once('value', snapshot => {
            if (snapshot.val()) {
              // has organization mapping
              snapshot.forEach(child => {
                let isUnique = snapshot.numChildren() == 1
                let isDefault = snapshot.numChildren() > 1 && snapshot.val()[child.key].default
                if (isUnique || isDefault) {
                  next('/localbusiness/' + child.key)
                }
              })
            } else {
              // no organization mapping
              next('/welcome')
            }
          })
        },
        {
          name: 'ListLocalBusiness',
          path : '/localbusiness/:organization',
          component : ListLocalBusiness
        },
        {
          name: 'NewLocalBusiness',
          path : '/localbusiness/:organization/newLocalBusiness',
          component : EditLocalBusiness
        },
        {
          name: 'EditLocalBusiness',
          path : '/localbusiness/:organization/:entityId/editLocalBusiness',
          component : EditLocalBusiness
        },
        {
          name: 'EditBatchLocalBusiness',
          path : '/localbusiness/:organization/batcheditionLocalBusiness',
          component : EditLocalBusiness,
          props: (route) => ({ selectedEntities: route.params.selectedEntities })
        },
        {
          path: '/offer',
          name: 'default_offer',
          beforeEnter: (to, from, next) =>
          // checks for the existing user and forwards to the first child if there is one mapped
          db.ref('/OrganizationUsers').child(firebase.auth().currentUser.email.replace(/\./gi, "%2E")).once('value', snapshot => {
            if (snapshot.val()) {
              // has organization mapping
              snapshot.forEach(child => {
                let isUnique = snapshot.numChildren() == 1
                let isDefault = snapshot.numChildren() > 1 && snapshot.val()[child.key].default
                if (isUnique || isDefault) {
                  next('/offer/' + child.key)
                }
              })
            } else {
              // no organization mapping
              next('/welcome')
            }
          })
        },
        {
          name: 'ListOffer',
          path : '/offer/:organization',
          component : ListOffer
        },
        {
          name: 'NewOffer',
          path : '/offer/:organization/newOffer',
          component : EditOffer
        },
        {
          name: 'EditOffer',
          path : '/offer/:organization/:entityId/editOffer',
          component : EditOffer
        },
        {
          name: 'EditBatchOffer',
          path : '/offer/:organization/batcheditionOffer',
          component : EditOffer,
          props: (route) => ({ selectedEntities: route.params.selectedEntities })
        },
/*
        {
          name: 'OrgLocationsOffer',
          path : '/offer/:organization',
          component : ListOffer
        },*/
        {
          name: 'Uploads',
          path : '/uploads',
          component : ListUpload,
          beforeEnter: (to, from, next) =>
          // checks for the existing user and forwards to the first child if there is one mapped
          db.ref('/OrganizationUsers').child(firebase.auth().currentUser.email.replace(/\./gi, "%2E")).once('value', snapshot => {
            if (snapshot.val()) {
              // has organization mapping
              snapshot.forEach(child => {
                let isUnique = snapshot.numChildren() == 1
                let isDefault = snapshot.numChildren() > 1 && snapshot.val()[child.key].default
                if (to.params.organization == child.key) {
                  next('/uploads/' + child.key)
                } else if (isUnique || isDefault) {
                  next('/uploads/' + child.key)
                }
              })
            } else {
              next('/welcome')
            }
          })
        },
        {
          name: 'ListUpload',
          path : '/uploads/:organization',
          component : ListUpload
        },
        {
          name: 'Welcome',
          path : '/welcome',
          component : Welcome
        },
        {
          name: 'Reports',
          path : '/reports',
          component : Reports,
          beforeEnter: (to, from, next) =>
          // checks for the existing user and forwards to the first child if there is one mapped
          db.ref('/OrganizationUsers').child(firebase.auth().currentUser.email.replace(/\./gi, "%2E")).once('value', snapshot => {
            if (snapshot.val()) {
              // has organization mapping
              snapshot.forEach(child => {
                let isUnique = snapshot.numChildren() == 1
                let isDefault = snapshot.numChildren() > 1 && snapshot.val()[child.key].default
                if (to.params.organization == child.key) {
                  next('/reports/' + child.key)
                } else if (isUnique || isDefault) {
                  next('/reports/' + child.key)
                }
              })
            } else {
              next('/welcome')
            }
          })
        },
        {
          name: 'Dashboard',
          path : '/dashboard',
          component : Full,
          beforeEnter: (to, from, next) => {
          // checks for the existing user and forwards to the first child if there is one mapped
          var orgName = null
          var orgSection = null
          console.log('h')
          db.ref('/OrganizationUsers').child(firebase.auth().currentUser.email.replace(/\./gi, "%2E")).once('value', snapshot => {
            console.log('looking for dashboard')

            if (snapshot.val()) {
              // has organization mapping
              snapshot.forEach(child => {
                let isUnique = snapshot.numChildren() == 1
                let isDefault = snapshot.numChildren() > 1 && snapshot.val()[child.key].default
                if (to.params.organization == child.key) {
                  orgName = child.key
                } else if (isUnique || isDefault) {
                  orgName = child.key
                  for (var section in snapshot.val()[child.key].sections) {
                    let sec = snapshot.val()[child.key].sections[section]
                    if (sec.hasOwnProperty('read') && sec['read'] == true && orgSection == null) {
                      orgSection = section
                      orgName = child.key
                      console.log('found section 2' + section)
                    }
                  }
                }
              })
              console.log('looking for dashboard')

              if (orgName == null) { // find first org with readable section
                  snapshot.forEach(child => {
                    if (orgSection == null) {
                      for (var section in snapshot.val()[child.key].sections) {
                        let sec = snapshot.val()[child.key].sections[section]
                        if (sec.hasOwnProperty('read') && sec['read'] == true && orgSection == null) {
                          orgSection = section
                          orgName = child.key
                          console.log('found section' + section)
                        }
                      }
                    }
                  })
              }
            } else {
              // next('/welcome')
            }
            if (orgSection != null && orgName != null) {
              next('/' + orgSection + '/' + orgName)
            } else {
              next('/welcome')
            }
          })
        }
       },
       {
         name: 'Dashboard Business',
         path : '/dashboard/:organization',
         component : Full,
         beforeEnter: (to, from, next) => {
           var orgName = to.params.organization
           var orgSection = null
           db.ref('/OrganizationUsers').child(firebase.auth().currentUser.email.replace(/\./gi, "%2E")).once('value', snapshot => {
             snapshot.forEach(child => {
               console.log(snapshot.val()[child.key].sections)
               if (orgSection == null && child.key === orgName) {
                 for (var section in snapshot.val()[child.key].sections) {
                   let sec = snapshot.val()[child.key].sections[section]
                   if (sec.read && orgSection == null) {
                     orgSection = section
                     console.log('found section' + section)
                   }
                 }
               }
             })
             if (orgSection != null) {
               console.log('org' + orgName)
               console.log('section' + orgSection)
               next('/' + orgSection + '/' + orgName)
             } else {
               next('/welcome')
             }
          })
       }
      },
        {
          name: 'Reports Organizations',
          path : '/reports/:organization',
          component : Reports
        },
        {
          name: 'Projects',
          path : '/projects',
          component : Projects,
          beforeEnter: (to, from, next) =>
          // checks for the existing user and forwards to the first child if there is one mapped
          db.ref('/OrganizationUsers').child(firebase.auth().currentUser.email.replace(/\./gi, "%2E")).once('value', snapshot => {
            if (snapshot.val()) {
              // has organization mapping
              snapshot.forEach(child => {
                let isUnique = snapshot.numChildren() == 1
                let isDefault = snapshot.numChildren() > 1 && snapshot.val()[child.key].default
                if (to.params.organization == child.key) {
                  next('/projects/' + child.key)
                } else if (isUnique || isDefault) {
                  next('/projects/' + child.key)
                }
              })
            } else {
              next('/welcome')
            }
          })
        },
        {
          name: 'Projects',
          path : '/projects/:organization',
          component : Projects
        },
        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'font-awesome',
              name: 'Font Awesome',
              component: FontAwesome
            },
            {
              path: 'simple-line-icons',
              name: 'Simple Line Icons',
              component: SimpleLineIcons
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/p404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login,
          beforeEnter: (to, from, next) => {
            if((from.name == 'Login') && (firebase.auth().currentUser) || (to.name == 'Login') && (firebase.auth().currentUser)) {
              if (to && to.query && to.query.redirect) {
                next(to.query.redirect)
              } else {
                next('/reports')
              }
            } else {
              next()
            }
          }
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    var currentUser = firebase.auth().currentUser
    if (!currentUser) {
      console.log("Login Screen")
      next({
        path: '/pages/login',
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      if (to.params.organization) {
        var orgs = []
        db.ref('/OrganizationUsers').child(firebase.auth().currentUser.email.replace(/\./gi, "%2E")).once('value', snapshot => {
          if (snapshot.val() && snapshot.hasChild(to.params.organization)) {
            if (snapshot.val()) {  // user node exists
              snapshot.forEach(child => {
                // handle auth
                db.ref('/Organizations').child(child.key).once('value', snapshot2 => {
                  var tmporg = snapshot2.val();
                  tmporg.id = child.key
                  if (child.key == to.params.organization) {  // org passed in matches value org
                    //console.log("setting org")
                    currentUser.getIdToken().then(data => 
                      store.commit('setAccessToken', data)
                    )
//                    firebase.auth().currentUser.getIdToken())
                    store.commit('setOrg', tmporg);
                    store.commit('updateAllSectionPermits', snapshot.val()[child.key].sections)
                    next()
                  } else {
                    orgs.push(tmporg)
                  }
                })
                store.commit('setLinkedOrgs', orgs);
              })
            } else {
              // user was not in the OrgUser table
              next('/dashboard')
            }
          } else {  //
            // console.log("IS REALLY NOT AUTHORIZED")
            next('/dashboard')
          }
        })
      } else {
        // organization not set so probably going to login
        // console.log("going to location")
        next()
      }
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js